import { buildRouteLocation, ROUTE_IDS } from '@/app/router/route-registry';

const DEAL_ROUTE_IDS_BY_TYPE = {
  proposta: ROUTE_IDS.DEAL_PROPOSALS,
  inCorso: ROUTE_IDS.DEALS_IN_PROGRESS,
  completato: ROUTE_IDS.DEALS_COMPLETED,
};

export function getDealRouteIdByType(dealType) {
  return DEAL_ROUTE_IDS_BY_TYPE[dealType] || null;
}

export function buildDealLocationByType(dealType) {
  const routeId = getDealRouteIdByType(dealType);
  return routeId ? buildRouteLocation(routeId) : null;
}

export function buildClientSearchLocation(clientId, clientName = '') {
  return buildRouteLocation(ROUTE_IDS.CLIENTS, {
    clientId,
    search: clientName,
  });
}

export function buildNewClientLocation() {
  return buildRouteLocation(ROUTE_IDS.CLIENTS, {
    action: 'new',
  });
}
